export default __webpack_public_path__ + "static/media/logo-icons.cb903c46.svg";